export const zoneData = {
    "641032": [
        { lat: 10.940005647052962, lng: 76.66957487367901 },
        { lat: 11.247264836008883, lng: 76.70802702211651 },
        { lat: 11.266121048234147, lng: 77.07881559633526 },
        { lat: 11.23110138602983, lng: 77.24635710024151 },
        { lat: 11.050548302380973, lng: 77.22163786196026 },
        { lat: 10.875278590143973, lng: 77.29030241274151 },
        { lat: 10.780859799590763, lng: 77.37544645571026 },
        { lat: 10.694508106938299, lng: 77.11177458071026 },
        { lat: 10.721495660724196, lng: 76.93324674867901 },
        { lat: 10.718797013548715, lng: 76.79591764711651 },
        { lat: 10.775463542635428, lng: 76.91127409242901 },
        { lat: 10.864489379064056, lng: 76.82063688539776 },
        { lat: 10.910340828611659, lng: 76.68605436586651 },
    ],
    "641033": [
        { lat: 11.022, lng: 76.96 },
        { lat: 11.022, lng: 76.963 },
        { lat: 11.019, lng: 76.963 },
        { lat: 11.019, lng: 76.96 },
    ],
    "641034": [
        { lat: 11.018, lng: 76.954 },
        { lat: 11.018, lng: 76.958 },
        { lat: 11.015, lng: 76.958 },
        { lat: 11.015, lng: 76.954 },
    ],
};

export const pinZoneData = {
    "641032": {
        "1000": [
            { lat: 10.783557891781488, lng: 76.91264738344464 },
            { lat: 10.815821874854418, lng: 76.96978459260761 },
            { lat: 10.877864620972298, lng: 76.97184452913105 },
            { lat: 10.901127326734947, lng: 76.9254959573537 },
            { lat: 10.884270474826941, lng: 76.85648808381855 },
            { lat: 10.836391819912638, lng: 76.84962162874042 },
            { lat: 10.780411289207521, lng: 76.90626988313495 },
        ],
        "1001": [
            { lat: 10.719480023928329, lng: 76.79752515953038 },
            { lat: 10.721504006998225, lng: 76.93416761558507 },
            { lat: 10.711383956324417, lng: 77.00626539390538 },
            { lat: 10.760631682592573, lng: 77.05295728843663 },
            { lat: 10.799079796216063, lng: 77.07012342613194 },
            { lat: 10.800428763575804, lng: 77.00283216636632 },
            { lat: 10.816615899103244, lng: 76.96987318199132 },
            { lat: 10.78086814422299, lng: 76.90738844078038 },
            { lat: 10.775471887417256, lng: 76.91288160484288 },
        ],
        "1002": [
            { lat: 10.71226400900769, lng: 77.00626539390538 },
            { lat: 10.694047118802057, lng: 77.11269544761632 },
            { lat: 10.724407993909308, lng: 77.20607923667882 },
            { lat: 10.758138725961246, lng: 77.24109815757726 },
            { lat: 10.815472306295874, lng: 77.18685316246007 },
            { lat: 10.799959593064271, lng: 77.07149671714757 },
            { lat: 10.758138725961246, lng: 77.05364393394444 },
        ],
        "1003": [
            { lat: 10.725757295483998, lng: 77.20745252769444 },
            { lat: 10.7810734695326, lng: 77.37499403160069 },
            { lat: 10.874817878969987, lng: 77.29053663413976 },
            { lat: 10.81614675389609, lng: 77.18685316246007 },
            { lat: 10.758138725961246, lng: 77.24041151206944 },
        ],
        "1004": [
            { lat: 10.879427816156625, lng: 76.97128616000859 },
            { lat: 10.816710949616477, lng: 76.96922622348515 },
            { lat: 10.800523819215924, lng: 77.00287185336796 },
            { lat: 10.79984933650681, lng: 77.0708497586414 },
            { lat: 10.816036503285096, lng: 77.18826614047734 },
            { lat: 10.876056276516216, lng: 77.28988967563359 },
            { lat: 11.004147882081094, lng: 77.23907790805546 },
            { lat: 10.95935199295436, lng: 77.04338096889616 },
            { lat: 10.92496974104447, lng: 77.03651451381803 },
            { lat: 10.900697517438008, lng: 77.04818748745085 },
        ],
        "1005": [
            { lat: 10.901820840662628, lng: 76.92490858192996 },
            { lat: 10.878558189072915, lng: 76.97091383095339 },
            { lat: 10.901146586486266, lng: 77.0481614505823 },
            { lat: 10.925418773415004, lng: 77.03648847694949 },
            { lat: 10.958452726854212, lng: 77.04369825478152 },
            { lat: 10.979686893281386, lng: 77.02824873085574 },
            { lat: 10.985079454466122, lng: 76.97640699501589 },
            { lat: 10.967890322453686, lng: 76.95718092079714 },
            { lat: 10.9513743326029, lng: 76.91563886757449 },
        ],
        "1006": [
            { lat: 10.98797475810061, lng: 76.97775239230211 },
            { lat: 10.979885958718638, lng: 77.02822083712633 },
            { lat: 10.958651806591163, lng: 77.0429837155443 },
            { lat: 11.0043201966104, lng: 77.23953599215562 },
            { lat: 11.230489216263267, lng: 77.247257834572 },
            { lat: 11.26685578076846, lng: 77.07971633066575 },
            { lat: 11.259448149336245, lng: 76.93071425547043 },
        ],
        "1007": [
            { lat: 10.951342591901092, lng: 76.91546921406865 },
            { lat: 10.96769005765373, lng: 76.9566679445374 },
            { lat: 10.984953007479122, lng: 76.97631962321006 },
            { lat: 10.979654403065432, lng: 77.02825742311713 },
            { lat: 10.979949311333383, lng: 77.02819305010077 },
            { lat: 10.987973159068563, lng: 76.97769414772115 },
            { lat: 11.258829649795196, lng: 76.93076860102644 },
            { lat: 11.2476934097618, lng: 76.70768637320815 },
        ],
        "1008": [
            { lat: 10.884385391704999, lng: 76.85641149553474 },
            { lat: 10.901129434320461, lng: 76.92545986713668 },
            { lat: 10.901909040618788, lng: 76.92485905231734 },
            { lat: 10.951518777918693, lng: 76.91557826080205 },
            { lat: 11.100055684087042, lng: 76.81122471389129 },
            { lat: 10.988288343974741, lng: 76.75503535498893 },
        ],
        "1009": [
            { lat: 11.007542696028237, lng: 76.67815285417397 },
            { lat: 10.988250479991532, lng: 76.75520769027925 },
            { lat: 11.100017492203815, lng: 76.81115648979356 },
            { lat: 11.247179464590879, lng: 76.70790404558508 },
        ],
        "1010": [
            { lat: 10.910561575271162, lng: 76.68602650460434 },
            { lat: 10.93998993062698, lng: 76.6695762082782 },
            { lat: 11.008052086278472, lng: 76.67808407979774 },
            { lat: 10.988499579840472, lng: 76.754880629084 },
            { lat: 10.884411405035506, lng: 76.8563073547521 },
            { lat: 10.836386300292526, lng: 76.8495634523936 },
            { lat: 10.864524097553426, lng: 76.82052699206105 },
        ]
    },
};

export const vendorData = {
    "641032": [{
        "zone_id": "1000",
        "vendor_id": 122331,
        "vendor_type": "food",
        "vendor_name": "praveen",
        "vendor_phone": "8908977987",
        "vendor_address": "street, city, state",
        "location": { lat: 10.885909861394513, lng: 76.9297716512695 }
    },
    {
        "zone_id": "1000",
        "vendor_id": 122332,
        "vendor_type": "food",
        "vendor_name": "muthuvel",
        "vendor_phone": "8908977985",
        "vendor_address": "streettt, cityyy, stateee",
        "location": { lat: 10.831573269581932, lng: 76.88291871446769 }
    },
    {
        "zone_id": "1000",
        "vendor_id": 122333,
        "vendor_type": "food",
        "vendor_name": "Anish",
        "vendor_phone": "8908977982",
        "vendor_address": "ssstreet, cccity, ssstate",
        "location": { lat: 10.864280469535823, lng: 76.87708222765129 }
    },
    {
        "zone_id": "1000",
        "vendor_id": 122334,
        "vendor_type": "food",
        "vendor_name": "Tamil",
        "vendor_phone": "8908977981",
        "vendor_address": "streeeet, cittty, staaate",
        "location": { lat: 10.828875608935583, lng: 76.94437348741691 }
    },
    {
        "zone_id": "1000",
        "vendor_id": 122335,
        "vendor_type": "food",
        "vendor_name": "saravana",
        "vendor_phone": "8908977983",
        "vendor_address": "street43, city21, state21",
        "location": { lat: 10.80425833390629, lng: 76.90077149767082 }
    },
    {
        "zone_id": "1001",
        "vendor_id": 1223316,
        "vendor_type": "grocery",
        "vendor_name": "Raj",
        "vendor_phone": "8908977984",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.750996367644705, lng: 76.92320474932632 }
    },
    {
        "zone_id": "1001",
        "vendor_id": 122337,
        "vendor_type": "grocery",
        "vendor_name": "Vinith",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.744250363006213, lng: 76.99598917315444 }
    },
    {
        "zone_id": "1001",
        "vendor_id": 122338,
        "vendor_type": "grocery",
        "vendor_name": "Noufal",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.78877120412215, lng: 76.99461588213882 }
    },
    {
        "zone_id": "1001",
        "vendor_id": 122339,
        "vendor_type": "grocery",
        "vendor_name": "Jagathish",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.786073158695057, lng: 77.04954752276382 }
    },
    {
        "zone_id": "1002",
        "vendor_id": 1223310,
        "vendor_type": "food",
        "vendor_name": "Anoob",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.76546648308028, lng: 77.13286328066098 }
    },
    {
        "zone_id": "1002",
        "vendor_id": 1223311,
        "vendor_type": "grocery",
        "vendor_name": "Abinav",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.730387294799517, lng: 77.07381176698911 }
    },
    {
        "zone_id": "1002",
        "vendor_id": 1223312,
        "vendor_type": "food",
        "vendor_name": "John",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.762093661433266, lng: 77.20427441347348 }
    },
    {
        "zone_id": "1003",
        "vendor_id": 1223313,
        "vendor_type": "food",
        "vendor_name": "Santhosh",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.822798666062507, lng: 77.26195263612973 }
    },
    {
        "zone_id": "1003",
        "vendor_id": 1223314,
        "vendor_type": "grocery",
        "vendor_name": "Vasanth",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.793122195617148, lng: 77.32169079530942 }
    },
    {
        "zone_id": "1004",
        "vendor_id": 1223315,
        "vendor_type": "food",
        "vendor_name": "Arun",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.886862833053383, lng: 77.07175183046567 }
    },
    {
        "zone_id": "1004",
        "vendor_id": 1223316,
        "vendor_type": "grocery",
        "vendor_name": "Mani",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.921249498109873, lng: 77.20976757753598 }
    },
    {
        "zone_id": "1005",
        "vendor_id": 1223317,
        "vendor_type": "grocery",
        "vendor_name": "Sayed Moosa",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.928232, lng: 76.971602 }
    },
    {
        "zone_id": "1006",
        "vendor_id": 1223318,
        "vendor_type": "grocery",
        "vendor_name": "Abdulla",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.067516729267384, lng: 77.02162670839536 }
    },
    {
        "zone_id": "1006",
        "vendor_id": 1223319,
        "vendor_type": "grocery",
        "vendor_name": "Ashif",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.04999545455586, lng: 77.15895580995786 }
    },
    {
        "zone_id": "1006",
        "vendor_id": 1223320,
        "vendor_type": "food",
        "vendor_name": "Sankar",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.210343256852484, lng: 77.18367504823911 }
    },
    {
        "zone_id": "1006",
        "vendor_id": 1223321,
        "vendor_type": "grocery",
        "vendor_name": "Vijay",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.149717919474398, lng: 77.07381176698911 }
    },
    {
        "zone_id": "1006",
        "vendor_id": 1223322,
        "vendor_type": "food",
        "vendor_name": "Surya",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.223813830145334, lng: 76.98180126894223 }
    },
    {
        "zone_id": "1007",
        "vendor_id": 1223323,
        "vendor_type": "food",
        "vendor_name": "Anandh",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.04325622402522, lng: 76.92961621034848 }
    },
    {
        "zone_id": "1007",
        "vendor_id": 1223324,
        "vendor_type": "grocery",
        "vendor_name": "Franklin",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.214384494782273, lng: 76.91588330019223 }
    },
    {
        "zone_id": "1008",
        "vendor_id": 1223325,
        "vendor_type": "food",
        "vendor_name": "Lance",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.013601772989484, lng: 76.81700634706723 }
    },
    {
        "zone_id": "1008",
        "vendor_id": 1223326,
        "vendor_type": "grocery",
        "vendor_name": "Navin",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.954283916159739, lng: 76.83073925722348 }
    },
    {
        "zone_id": "1009",
        "vendor_id": 1223327,
        "vendor_type": "food",
        "vendor_name": "Michale",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.11064155276231, lng: 76.74147534120786 }
    },
    {
        "zone_id": "1009",
        "vendor_id": 1223328,
        "vendor_type": "grocery",
        "vendor_name": "Tommy",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 11.04864762083054, lng: 76.73186230409848 }
    },
    {
        "zone_id": "1010",
        "vendor_id": 1223329,
        "vendor_type": "grocery",
        "vendor_name": "Akash",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.946570951228978, lng: 76.73432305284949 }
    },
    {
        "zone_id": "1010",
        "vendor_id": 1223330,
        "vendor_type": "food",
        "vendor_name": "Emily",
        "vendor_phone": "8908977985",
        "vendor_address": "street1, city1, state1",
        "location": { lat: 10.8818453241823, lng: 76.83114006945105 }
    },],
    "641033": [{
        "vendor_id": 1223331,
        "vendor_type": "food",
        "vendor_name": "anish",
        "vendor_phone": "8908977989",
        "vendor_address": "street2, city2, state2",
        "location": { lat: 11.022, lng: 76.960 }
    },
    {
        "vendor_id": 1223332,
        "vendor_type": "grocery",
        "vendor_name": "saravana",
        "vendor_phone": "8908977983",
        "vendor_address": "street3, city3, state3",
        "location": { lat: 11.022, lng: 76.963 }
    }]
};